import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {Employee} from 'main/stores/employees';

class TimeTrackingProject extends DomainObject {
  name;
  employees;

  _relations = {
    employees: [Employee],
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      employees: observable
    });

    this.merge(other);
  }
}

export default TimeTrackingProject;
